
export const AUTH_TOKEN = "J_AUTH_TOKEN";
export const REFRESH_TOKEN = "J_REFRESH_TOKEN";

export const SKU_TAG_COUNT = 7; // This really only works for joyya at this time

export const ABSENT_WITH_REASON = 'ABSENT_WITH_REASON';

export const STATUS_OPTIONS = [
    {
        key: 'Absent-Village',
        text: 'In village',
        value:'VILLAGE',
    },
    {
        key: 'Absent-Education',
        text: 'Other education',
        value:'EDUCATION',
    },
    {
        key: 'Absent-Wedding',
        text: 'Wedding',
        value: 'WEDDING',
    },
    {
        key: 'Absent-Funeral',
        text: 'Funeral',
        value: 'FUNERAL',
    },
    {
        key: 'Absent-Sickness',
        text: 'Sickness',
        value: 'SICKNESS',
    },
    {
        key: 'Absent-Religious-Festival',
        text: 'Religious Festival',
        value: 'RELIGIOUS',
    },
    {
        key: 'Absent-With-REASON',
        text: 'Other reason',
        value: ABSENT_WITH_REASON,
    },
    {
        key: 'PENDING',
        text: 'Pending',
        value: 'PENDING'
    },
];

export const FULL_STATUS_OPTIONS = [
    ...STATUS_OPTIONS,
    {
        key: 'ABSENT',
        text: 'Absent',
        value: 'ABSENT',
    },
    {
        key: 'PRESENT',
        text: 'Present',
        value: 'PRESENT',
    },
];
